import { Typography } from "@material-ui/core";

export default function Header() {
  return <Typography variant="h1">
      UN Singles
  </Typography>;
}
